var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "list-title"
  }, [_vm._t("default", function () {
    return [_vm._t("left", function () {
      return [_vm._v(_vm._s(_vm.title))];
    }), _vm._t("right", function () {
      return [_vm._v(_vm._s(_vm.desc))];
    })];
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };